/**
 * KAN-980: итог выдачи или возврата аккаунтов: строка на аккаунт и предупреждения.
 */
import { accountTitle, TRANSFER_MOVED, transferOutcome } from '@/lib/platform';
import type { TransferResponse } from '@/services/api/platform';

interface TransferResultsProps {
  title: string;
  result: TransferResponse;
  onDismiss: () => void;
}

export function TransferResults({ title, result, onDismiss }: TransferResultsProps) {
  return (
    <section className="space-y-2 rounded-lg border border-gray-200 bg-white p-4" aria-label={title}>
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        <button type="button" className="text-xs text-gray-500 hover:text-gray-700" onClick={onDismiss}>
          Скрыть
        </button>
      </div>
      <ul className="space-y-1">
        {result.results.map((row) => (
          <li key={row.account_id} data-testid="platform-transfer-result" className="flex flex-wrap gap-2 text-sm">
            <span className="font-medium text-gray-900">{accountTitle(row)}</span>
            <span className={row.status === TRANSFER_MOVED ? 'text-green-700' : 'text-red-600'}>
              {transferOutcome(row)}
            </span>
          </li>
        ))}
      </ul>
      {result.warnings.length > 0 && (
        <ul className="space-y-1 text-sm text-amber-700">
          {result.warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      )}
    </section>
  );
}
